import axiosInstance, { ApiKeys, getApiUrl, logError } from 'src/utils/ApiHelper';
import { filtersQueryParams, queryParam } from './interface';
import { Dispatch } from '@reduxjs/toolkit';
import { setFilters, setTeamLeadApiCalling, setTeamLeadData } from 'src/reducers/TeamLeadSlice';

export const getTeamLeadDashboard = (queryParams: queryParam) => (dispatch: Dispatch) => {
  dispatch(setTeamLeadApiCalling());
  const url = getApiUrl(ApiKeys.GET_TEAM_LEAD_CASES);
  axiosInstance
    .get(url, { params: queryParams, headers: { includeInUptimeMetrics: true } })
    .then(response => {
      dispatch(setTeamLeadData(response.data));
      dispatch(setTeamLeadApiCalling());
    })
    .catch(error => {
      dispatch(setTeamLeadApiCalling());
      logError('Error inside getTeamLeadDashboardAPI', error);
    });
};

export const getTeamLeadDashboardFilters =
  (queryParams: filtersQueryParams) => (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_TEAM_LEAD_FILTERS);
    axiosInstance
      .get(url, { params: queryParams })
      .then(response => {
        dispatch(setFilters(response));
      })
      .catch(error => {
        logError('Error inside getTeamLeadDashboardFilters', error);
      });
  };
